import type { NavItem, SiteConfig, StoreInfo } from '@/types'

import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: "Tideline Tackle",
    description: "Fishing tackle, bait and fly gear picked by local anglers. Reserve rods, reels and lures online, then pay when you pick them up in store.",
    url: getOrigin()
}

/*
 * Store details shown in the header, footer, home page and contact page.
 * Change them here and every page follows.
 */
export const storeInfo: StoreInfo = {
    locale: 'en-US',
    currency: 'USD',
    phone: "(555) 555-0142",
    phoneHref: 'tel:+15555550142',
    street: "214 Harbor Road",
    city: "Port Wren",
    hours: [
        { days: "Monday to Friday", time: "6:00 am to 6:00 pm" },
        { days: "Saturday", time: "5:30 am to 5:00 pm" },
        { days: "Sunday", time: "6:00 am to 2:00 pm" }
    ]
}

export const directionsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(`${storeInfo.street}, ${storeInfo.city}`)}`

export const mainNav: Array<NavItem> = [
    { label: "Shop", href: '/shop' },
    { label: "Pickup", href: '/#pickup' },
    { label: "Services", href: '/#services' },
    { label: "About", href: '/#about' },
    { label: "Visit us", href: '/contact' }
]

export const contactTopics: Array<{ value: string, label: string }> = [
    { value: 'general', label: "General question" },
    { value: 'availability', label: "Product availability" },
    { value: 'repairs', label: "Repairs and servicing" },
    { value: 'order', label: "An existing pickup order" }
]
